import { render, staticRenderFns } from "./SelectOrderItemComments.vue?vue&type=template&id=972c9c7e&scoped=true&"
import script from "./SelectOrderItemComments.vue?vue&type=script&lang=js&"
export * from "./SelectOrderItemComments.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrderItemComments.vue?vue&type=style&index=0&id=972c9c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972c9c7e",
  null
  
)

export default component.exports